import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { isNull } from 'lodash'
import { useUser } from 'modules/User/remote'
import { isFullUser } from 'utilities/user'

export const useRequiresLogin = (route = '/login') => {
  const router = useRouter()
  const { user, isUserLoading } = useUser()
  useEffect(() => {
    const mightBeLoggedIn = isUserLoading || isFullUser(user?.role)
    if (!mightBeLoggedIn) {
      const currentPath = window.location.pathname
      const query = (route === '/login') && currentPath
        ? `?redirectTo=${encodeURIComponent(currentPath)}`
        : ''
      // console.log({ route, query })
      router.push(`${route}${query}`)
    }
  }, [user, isUserLoading])
}

export const useRequiresGuestLogin = (route = '/') => {
  const router = useRouter()
  const { user, isUserLoading } = useUser()
  useEffect(() => {
    if (!isUserLoading && isNull(user?.role)) {
      console.log('REQUIRES GUEST LOGIN', user, isUserLoading, isNull(user?.role))
      console.log('REdirect to /')
      router.push(route)
    }
  }, [user, isUserLoading])
}

export default useRequiresLogin
